import folkvangrVfxVideo from '../../../videos/VFX_Folkvangr.mp4';
import ModalShell from '../ModalShell';
import './FolkvangrModal.css';

const videos = [
  {
    src: folkvangrVfxVideo,
    title: 'Folkvangr real-time VFX showcase',
  },
];

function FolkvangrModal({ project, onClose }) {
  return (
    <ModalShell titleId="folkvangr-modal-title" onClose={onClose}>
      <div className="folkvangr-modal">
        <div className="folkvangr-modal__body">
          <p className="eyebrow">VFX &amp; Technical Art</p>
          <h2 id="folkvangr-modal-title">{project.title}</h2>
          {project.tools.length > 0 && (
            <ul className="folkvangr-modal__tools">
              {project.tools.map((tool) => <li key={tool}>{tool}</li>)}
            </ul>
          )}
          {Array.isArray(project.modalDescription)
            ? project.modalDescription.map((paragraph) => <p key={paragraph}>{paragraph}</p>)
            : project.modalDescription && <p>{project.modalDescription}</p>}
          <a
            className="folkvangr-modal__studio-link"
            href={project.url}
            target="_blank"
            rel="noreferrer"
          >
            View SilverLine Studios
          </a>
        </div>

        <div className="folkvangr-modal__videos">
          {videos.map((video) => (
            <video
              aria-label={video.title}
              autoPlay
              className="folkvangr-modal__video"
              key={video.src}
              loop
              muted
              playsInline
              src={video.src}
            />
          ))}
        </div>
      </div>
    </ModalShell>
  );
}

export default FolkvangrModal;
